import { StaleTime, useQuery } from '@tanstack/react-query';
import { getInternalConversation } from '../../services/chats';
import useUser from '../global/useUser';

export function getInternalConversationQueryOptions(
  conversationId: string,
  userId: string | undefined,
  businessId: string | undefined,
) {
  return {
    queryKey: [
      'internal-chat-conversation',
      userId,
      businessId,
      conversationId,
    ],
    queryFn: () => getInternalConversation(conversationId),
  };
}

interface Options {
  enabled?: boolean;
  staleTime?: StaleTime<any, any>;
}

function useGetInternalConversation(
  conversationId: string | null | undefined,
  { enabled = true, staleTime }: Options = {},
) {
  const { user } = useUser();

  const { data, isFetching, isLoading, isError, error, refetch } = useQuery({
    ...getInternalConversationQueryOptions(
      conversationId!,
      user?.userId,
      user?.business?.id,
    ),
    enabled:
      !!conversationId && !!user?.userId && !!user?.business?.id && enabled,
    ...(staleTime ? { staleTime } : {}),
  });

  return {
    data,
    isFetching,
    isLoading,
    isError,
    error,
    refetch,
  };
}

export default useGetInternalConversation;
